// @ts-nocheck
import React from 'react';

import {
  ExcelIcon,
  FileIcon,
  VideoIcon,
} from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constantSvg';
import { DescriptionIcon } from 'assets/icons';

const FileTypeIcon = ({ fileType, classes }) => {
  switch (fileType) {
    case 'xlsx':
    case 'xlsm':
    case 'xlsb':
    case 'xls':
      return <ExcelIcon className={classes.fileIcon} />;
    case 'docx':
    case 'docm':
    case 'doc':
    case 'txt':
      return <DescriptionIcon fontSize="small" color="error" />;
    case 'pdf':
      return <FileIcon className={classes.fileIcon} />;
    case 'mp4':
    case 'mov':
    case 'avi':
    case 'mpg':
    case 'wmv':
    case 'ogg':
    case 'webm':
      return <VideoIcon className={classes.fileIcon} />;
    default:
      return null;
  }
};

export default FileTypeIcon;
